export const mascararCPF = (cpf) => {
  if (cpf.length !== 11 || !/^\d+$/.test(cpf)) {
    throw new Error("CPF inválido. Deve conter 11 dígitos numéricos.");
  }

  const parteMascarada = "•••";
  const parteVisivel1 = cpf.slice(3, 6);
  const parteVisivel2 = cpf.slice(6, 9);
  const parteVisivel3 = "••";

  const cpfMascarado = `${parteMascarada}.${parteVisivel1}.${parteVisivel2}-${parteVisivel3}`;

  return cpfMascarado;
};

export const formatarCPF = (cpf) => {
  if (cpf.length !== 11 || !/^\d+$/.test(cpf)) {
    throw new Error("CPF inválido. Deve conter 11 dígitos numéricos.");
  }

  const parteMascarada = cpf.slice(0, 3);
  const parteVisivel1 = cpf.slice(3, 6);
  const parteVisivel2 = cpf.slice(6, 9);
  const parteVisivel3 = cpf.slice(9, 11);

  const cpfMascarado = `${parteMascarada}.${parteVisivel1}.${parteVisivel2}-${parteVisivel3}`;

  return cpfMascarado;
};

export const formatarCNPJ = (cnpj) => {
  if (cnpj.length !== 14 || !/^\d+$/.test(cnpj)) {
    throw new Error("CNPJ inválido. Deve conter 14 dígitos numéricos.");
  }

  const parte1 = cnpj.slice(0, 2);
  const parte2 = cnpj.slice(2, 5);
  const parte3 = cnpj.slice(5, 8);
  const parte4 = cnpj.slice(8, 12);
  const parte5 = cnpj.slice(12, 14);

  const cnpjFormatado = `${parte1}.${parte2}.${parte3}/${parte4}-${parte5}`;

  return cnpjFormatado;
};
